module.exports = __webpack_public_path__ + "img/train-dark-grey.a3bd2ca0.svg";